import { CLUB_LAUNCH_ID } from './whats-new.const';

/**
 * Pure eligibility for the Club "What's New" announcement. The host
 * (use-whats-new.ts) gathers the inputs; this function only decides.
 * Other-modal occupancy and debouncing stay in the host.
 */
export interface IClubWhatsNewInput {
  seenWhatsNew: string[];
  forcePreview: boolean;
  isLoggedIn: boolean;
  hasRestaurant: boolean;
  effectiveTier: number;
  hasClubManage: boolean;
  isPos: boolean;
  isClubRoute: boolean;
  /** getProgram settled successfully (false while pending or after failure). */
  programKnown: boolean;
  /** A program row exists for this restaurant (active OR paused). */
  programExists: boolean;
}

export interface IWhatsNewEvaluation {
  show: boolean;
  /** Persist as seen without showing (user already reached the feature). */
  markSeen: boolean;
  reason: string;
}

const nothing = (reason: string): IWhatsNewEvaluation => ({
  show: false,
  markSeen: false,
  reason,
});

export function evaluateClubWhatsNew(
  input: IClubWhatsNewInput
): IWhatsNewEvaluation {
  if (!input.isLoggedIn || !input.hasRestaurant) return nothing('no-session');

  // Preview may show even if seen or a program exists; never persists.
  if (input.forcePreview)
    return { show: true, markSeen: false, reason: 'force-preview' };

  const seen = input.seenWhatsNew.includes(CLUB_LAUNCH_ID);

  // They found Club on their own — persist without showing. Deliberately
  // before the getProgram gates: no need to wait for the fetch. ClubTopup-only
  // visits must NOT burn the announcement (they may gain ClubManage later).
  if (input.isClubRoute && input.hasClubManage && !seen)
    return { show: false, markSeen: true, reason: 'club-route' };

  if (seen) return nothing('already-seen');
  if (input.isPos) return nothing('pos');
  if (input.effectiveTier < 1) return nothing('free-tier');
  if (!input.hasClubManage) return nothing('no-club-manage');
  if (!input.programKnown) return nothing('program-unknown');
  if (input.programExists) return nothing('program-exists');

  return { show: true, markSeen: false, reason: 'eligible' };
}
